/**
 * Commission page — "คำนวณคอมมิชชั่น" (runs only).
 *
 * Packages (ตั้งค่าแพคเกจ) ย้ายไปอยู่ใน Wage hub
 * (`/owner/wage#commission`) แทน → หน้านี้โฟกัสที่ workflow คำนวณรอบ
 * อย่างเดียว ไม่มี tab. legacy URL `/hr/commission-packages` redirect
 * ไป Wage hub ใน App.tsx.
 */
import { AdminLayout } from '../../components/layout/AdminLayout';
import { HRCommissionRunsContent } from './CommissionRuns';

export function HRCommission() {
  return (
    <AdminLayout title="คำนวณคอมมิชชั่น">
      <HRCommissionRunsContent />
    </AdminLayout>
  );
}
